// frontend/src/slices/auditLogApiSlice.js
import { apiSlice } from './apiSlice';

const AUDIT_URL = '/api/audit';

export const auditLogApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    getShiftAuditLogs: builder.query({
      query: (params) => ({
        url: `${AUDIT_URL}/shifts`,
        params,
      }),
      providesTags: ['AuditLog'],
      keepUnusedDataFor: 30,
    }),

    getShiftAuditTrail: builder.query({
      query: (shiftId) => ({
        url: `${AUDIT_URL}/shifts/${shiftId}`,
      }),
      providesTags: (result, error, id) => [{ type: 'AuditLog', id }],
      keepUnusedDataFor: 30,
    }),

    getAuditPerformers: builder.query({
      query: () => ({ url: `${AUDIT_URL}/performers` }),
      keepUnusedDataFor: 120,
    }),

  }),
});

export const {
  useGetShiftAuditLogsQuery,
  useGetShiftAuditTrailQuery,
  useGetAuditPerformersQuery,
} = auditLogApiSlice;